﻿(function (angular) {
  "use strict";

  angular.module("Toyota").directive("tyRichtextAnalytics", [
    "$analytics",
    function ($analytics) {
      return {
        scope: true,
        restrict: "A",
        link: function (scope, element, attrs) {
          const regex = /\b(?:\w+\s+)*?(link|button|image|tel)(?:\s+\w+)*\b/g;

          var analyticsStyle = attrs.tyRichtextAnalytics;

          if (!analyticsStyle) {
            return;
          }

          // the getAdditionalAnalytic function will get the additional attributes from the HTML tag and convert them to JSON object
          // the additional attributes are used to pass additional information to the analytic event
          // the additional attributes are passed as a string in the analyticsProperties attribute
          // the string should be in JSON format
          // example: analyticsProperties='{"event_name": "gaClick", "eventCategory": "link", "eventAction": "click", "eventLabel": "https://www.toyota.com.au/"}'
          // This analytic mechanism is for workaround. The ticket created to remove this workaroundin future is https://toyotaau.atlassian.net/browse/SIR-6564
          var analyticsHandlers = {
            link: function () {
              var additionalAnalyticProperties = getAdditionalAnalytic();

              $analytics.eventTrack(additionalAnalyticProperties && additionalAnalyticProperties["event_name"] ? 
                  additionalAnalyticProperties["event_name"] : "gaClick", {
                eventCategory: "link",
                eventAction: element.text().trim(),
                eventLabel: element.attr("href"),
                click_text: element.text().trim(),
                link_url: element.attr("href"),
                ...additionalAnalyticProperties,
              });
            },
            button: function () {
              var additionalAnalyticProperties = getAdditionalAnalytic();
                $analytics.eventTrack(additionalAnalyticProperties && additionalAnalyticProperties["event_name"] ? 
                  additionalAnalyticProperties["event_name"] : "gaClick", {
                eventCategory: "button",
                eventAction: element.text().trim(),
                eventLabel: element.attr("href"),
                click_text: element.text().trim(),
                link_url: element.attr("href"),
                ...additionalAnalyticProperties,
              });
            },
            image: function () {
              var imageAlt = element.find("img").attr("alt");
              var additionalAnalyticProperties = getAdditionalAnalytic();

              $analytics.eventTrack(additionalAnalyticProperties && additionalAnalyticProperties["event_name"] ? 
                  additionalAnalyticProperties["event_name"] : "gaClick", {
                eventCategory: "image",
                eventAction: imageAlt.trim() || element.text().trim(),
                eventLabel: element.attr("href"),
                click_text: imageAlt.trim() || element.text().trim(),
                link_url: element.attr("href"),
                ...additionalAnalyticProperties,
              });
            },
            tel: function () {
              var additionalAnalyticProperties = getAdditionalAnalytic();

              $analytics.eventTrack(additionalAnalyticProperties && additionalAnalyticProperties["event_name"] ? 
                  additionalAnalyticProperties["event_name"] : "gaClick", {
                eventCategory: "click to call",
                eventAction: element.text().trim(),
                eventLabel: window.location.href,
                click_text: element.text().trim(),
                link_url: window.location.href,
                ...additionalAnalyticProperties,
              });
            },
          };

          element.on("click auxclick", function (e) {
            if (e.button !== 0 && e.button !== 1) {
              return;
            }

            const words = analyticsStyle.trim().split(/\s+/);
            if (words.length > 1) {
              //only use regex to extract the link, button, image, tel from the analyticsStyle if there are multiple words
              const match = regex.exec(analyticsStyle);
              if (match && match.length > 1) {
                analyticsStyle = match[1];
              }
            }

            if (analyticsHandlers[analyticsStyle]) {
              analyticsHandlers[analyticsStyle]();
            }
          });

          function getAdditionalAnalytic() {
            try {
              var gaProps = attrs.analyticsProperties;
              
              if (gaProps) {
                var additionalAnalyticProperties = convertStringToObject(gaProps);
                return additionalAnalyticProperties;
              }
              return {};
            } catch (error) {
              // suppress error from throwing if JSON.parse fails
              return {};
            }
          }

          function convertStringToObject(str) {
            if (!str) return {};

            // Step 1: Replace single quotes around property values with double quotes
            str = str.replace(/:\s*'([^']*)'/g, ': "$1"');
          
            // Step 2: Add double quotes around property names
            str = str.replace(/(\w+):/g, '"$1":');
          
            // Step 3: Parse the JSON string
            try {
              const obj = JSON.parse(str);
              return obj;
            } catch (error) {
              console.error('Error parsing JSON string:', error);
              return {};
            }
          }
        },
      };
    },
  ]);
})(window.angular);
